import { getDate } from 'app/rm/erp/common/utils/date-utils';
import { ErpBahncardValue }
    from '../../shared/model/travelmanagement-values';
export interface BahncardBackend {
    id?: number;
    readonly objGuid?: string;
    readonly lockVersion?: number;
    pgdJoinId?: number;

    validFromDateFirstBc?: number;
    validToDateFirstBc?: number;
    discountFirstBc?: number;

    validFromDateSecondBc?: number;
    validToDateSecondBc?: number;
    discountSecondBc?: number;

    changeBahncard?: boolean;
    changeText?: string;
    changeFromDate?: number;
    changeToDate?: number;

    bahncardSelected?: ErpBahncardValue;
}

export class Bahncard {
    id?: number;
    readonly objGuid?: string;
    readonly lockVersion?: number;
    pgdJoinId?: number;

    validFromDateFirstBc?: Date;
    validToDateFirstBc?: Date;
    discountFirstBc?: number;

    validFromDateSecondBc?: Date;
    validToDateSecondBc?: Date;
    discountSecondBc?: number;

    changeBahncard?: boolean;
    changeText?: string;
    changeFromDate?: Date;
    changeToDate?: Date;

    bahncardSelected?: ErpBahncardValue;
}

export class BahncardFactory {
    static createFromBackendModel( backendModel: BahncardBackend ): Bahncard {
        const frontendModel: Bahncard = {
            id: backendModel.id,
            objGuid: backendModel.objGuid,
            lockVersion: backendModel.lockVersion,
            pgdJoinId: backendModel.pgdJoinId,
            validFromDateFirstBc: getDate( backendModel.validFromDateFirstBc ),
            validToDateFirstBc: getDate( backendModel.validToDateFirstBc ),
            discountFirstBc: backendModel.discountFirstBc,

            validFromDateSecondBc: getDate( backendModel.validFromDateSecondBc ),
            validToDateSecondBc: getDate( backendModel.validToDateSecondBc ),
            discountSecondBc: backendModel.discountSecondBc,

            changeBahncard: backendModel.changeBahncard,
            changeText: backendModel.changeText,
            changeFromDate: getDate( backendModel.changeFromDate ),
            changeToDate: getDate( backendModel.changeToDate ),

            bahncardSelected: backendModel.bahncardSelected,
        };
        return frontendModel;
    }

    static createFromFrontendModel( frontendModel: Bahncard ): BahncardBackend {
        const backendModel: BahncardBackend = {
            id: frontendModel.id,
            objGuid: frontendModel.objGuid,
            lockVersion: frontendModel.lockVersion,
            pgdJoinId: frontendModel.pgdJoinId,
            validFromDateFirstBc: frontendModel.validFromDateFirstBc?.getTime(),
            validToDateFirstBc: frontendModel.validToDateFirstBc?.getTime(),
            discountFirstBc: frontendModel.discountFirstBc,

            validFromDateSecondBc: frontendModel.validFromDateSecondBc?.getTime(),
            validToDateSecondBc: frontendModel.validToDateSecondBc?.getTime(),
            discountSecondBc: frontendModel.discountSecondBc,

            changeBahncard: frontendModel.changeBahncard,
            changeText: frontendModel.changeText,
            changeFromDate: frontendModel.changeFromDate?.getTime(),
            changeToDate: frontendModel.changeToDate?.getTime(),

            bahncardSelected: frontendModel.bahncardSelected,
        };
        return backendModel;
    }
}
